import React from 'react';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { MBSelectableDot } from './selectable';
import { MBUserRow } from './user';

interface MBSelectableUserRowProps {
  user: API.ShortUserFragment;
  selected: boolean;
  radio: boolean;
  onPress: (user: API.ShortUserFragment) => void;
}

export class MBSelectableUserRow extends React.PureComponent<MBSelectableUserRowProps> {
  onPress = () => this.props.onPress(this.props.user);
  render() {
    return (
      <MBUserRow
        user={this.props.user}
        onPress={this.onPress}
        subtitle={!!this.props.user.username && `@${this.props.user.username}`}
        icon={
          <View fill center>
            <MBSelectableDot radio={this.props.radio} selected={this.props.selected} />
          </View>
        }
      />
    );
  }
}
